import { useEffect, useState } from "react";
import { Network } from "lucide-react";
import { api } from "@/lib/api";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const fmt = (v) => ({ wifi: "Wi-Fi", cabo: "Cabo de rede" }[v] || (v ? v : "Não identificado"));

const Item = ({ a }) => (
  <div className={`border-b px-3 py-2 text-xs ${a.lido ? "" : "bg-amber-50"}`} data-testid={`alerta-rede-${a.id}`}>
    <div className="font-semibold text-slate-800">{a.equipamento_nome} <span className="font-mono text-slate-400">{a.sn}</span></div>
    <div className="text-slate-500">{a.empresa_nome}</div>
    {a.mudancas.map((m, i) => (
      <div key={i} className="text-slate-700">{m.campo}: {fmt(m.de)} → <b>{fmt(m.para)}</b></div>
    ))}
    <div className="text-[10px] text-slate-400">{new Date(a.created_at).toLocaleString("pt-BR")}</div>
  </div>
);

export const AlertasRedeBell = () => {
  const [d, setD] = useState({ nao_lidos: 0, itens: [] });
  const carregar = () => { api.get("/superadmin/alertas-rede").then((r) => setD(r.data)).catch(() => {}); };
  useEffect(() => {
    carregar();
    const t = setInterval(carregar, 60000);
    return () => { clearInterval(t); };
  }, []);
  const abrir = (open) => {
    if (!open && d.nao_lidos) api.post("/superadmin/alertas-rede/lidos").then(carregar).catch(() => {});
  };
  return (
    <Popover onOpenChange={abrir}>
      <PopoverTrigger asChild>
        <button data-testid="btn-alertas-rede" title="Alertas de troca de rede dos coletores"
          className="relative h-9 w-9 grid place-items-center rounded-md border border-slate-200 hover:bg-slate-100 text-slate-700">
          <Network size={16} />
          {d.nao_lidos > 0 && (
            <span data-testid="alertas-rede-badge" className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-red-600 text-white text-[10px] font-bold grid place-items-center">
              {d.nao_lidos > 99 ? "99+" : d.nao_lidos}
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0 max-h-[70vh] overflow-y-auto" data-testid="alertas-rede-lista">
        <div className="px-3 py-2 text-sm font-bold border-b">Trocas de rede dos coletores</div>
        {d.itens.length ? d.itens.map((a) => <Item key={a.id} a={a} />)
          : <div className="px-3 py-4 text-xs text-slate-500" data-testid="alertas-rede-vazio">Nenhuma troca de rede registrada.</div>}
      </PopoverContent>
    </Popover>
  );
};
